<button aria-label="Herunterladen"
    mat-icon-button
    matTooltip="{{
        'OUTGOING-GOODS.FOLDER-VIEW.HOVER-TEXT.DOWNLOAD-DELIVERY-NOTE'
            | translate
    }}"
    (click)="downloadDeliveryNote()">
    <mat-icon fontSet="material-symbols-outlined">file_download</mat-icon>
</button>
